import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface Machine {
  folio: string; //1 ) Folio Interno (Entero, no se asigna automático, solo se escribe)
  name: string; //2 ) Nombre	(Texto)
  date: string; //3 ) Fecha de adquisición (Campo fecha)
  warrantyTime: string; //4 ) Periodo de Garantia (Texto)
  notes: string; //5 ) Notas (Texto)
  headers: number; //6 ) Cantidad de Cabezas (Entero)
  maxWidth: number; //7 ) Tamaño máximo ancho
  maxWidthUnitId: string; //8 ) Unidad de Medida para el 7
  maxLong: number; //9 ) Tamaño máximo largo
  maxLongUnitId: string; //10) Unidad de Medida para 9
  clawWidth: number; //11) Medida de la pinza ancho
  clawWidthUnitId: string; //12) Unidad de medida para 11
  clawLong: number; //13) Medida de la pinza largo
  clawLongUnitId: string; //14) Unidad de Medida para 13
  activityIds: string[]; //15) Actividades relacionadas
}

export interface MachineId extends Machine {
  id: string;
}

@Injectable()
export class MachineService {

  collection: string;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.MACHINE_COLLECTION;
  }

  /**
   * Get all machines with references
   * @return {Observable} Arrays of machines
   */
  getMachines() {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }

  /**
  * Get machine data
  * @param {string} sid - The id of the machine
  * @return {Observable} The Machine Object
  */
  getMachine(sid: string) {
    return this.afh.docWithIds$(this.collection + '/' + sid);
  }
  getMachineByFolio(folio: string){
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('folio', '==', folio) );
  }

  /**
  * Create new machine
  * @param {Machine} machine - The data of the machine
  */
  addMachine(machine: Machine) {
    this.afh.add(`${this.collection}`, machine, id => {console.log(`Uploaded machine ${id}`)});
  }

  /**
   * Update current machine
   * @param {string} sid  - The id of the machine
   * @param {Machine} machine - The data of the machine
   */
  updateMachine(sid: string, machine: Machine) {
    this.afh.update(`${this.collection}/${sid}`, machine);
  }

  /**
   * Delete current machine
   * @param {string} sid - The id of the machine
   */
  deleteMachine(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  window = {
    add: () => { this.router.navigate([`/new_machine`]) },
    edit: (id) => { this.router.navigate([`/edit_machine/${id}`]) },
    view: (id) => { this.router.navigate([`/vw_machine/${id}`]) },
    read: () => { this.router.navigate([`/machine`]) }
  }
}
